import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0367a199"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "header" }
const _hoisted_2 = { class: "header-container" }
const _hoisted_3 = { class: "text-title" }
const _hoisted_4 = { class: "title-name" }
const _hoisted_5 = { class: "slogan-name" }
const _hoisted_6 = {
  key: 0,
  class: "info"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "iconfont icon-lingdang" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-renxiangziyuan" })
], -1))
const _hoisted_9 = [
  _hoisted_8
]

import screenfull from 'screenfull';
import { useRoute, useRouter, } from 'vue-router';
import { useStore, } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { sysConfig, } = window as any;

const store = useStore();

const router = useRouter();
const route = useRoute();
const openUrl = localStorage.getItem('openUrl') || '';

const handlerClick = () => {
  router.push('/');

  if (route.path === '/') {
    router.go(0);
  }
};

const { userInfo, } = store.state.login;

const fullScreen = () => {
  if (!screenfull.isEnabled) {
    return false;
  }
  screenfull.toggle();
};

const toCockpit = () => {
  // 管理员账号
  if (userInfo.name === '19999999999') {
    router.push('/logged/account/adminManage');

    return;
  }
  router.push('/cockpit');
  fullScreen();
};

const toLoggedPage = () => {
  router.push(openUrl || '');
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "web-title",
        onClick: handlerClick
      }, [
        _createElementVNode("div", {
          class: "bg-logo",
          style: _normalizeStyle({
          backgroundImage: 'url(' + _unref(sysConfig).indexLogo + ')',
          backgroundRepeat: 'no-repeat',
          backgroundSize: '100%',
        })
        }, null, 4),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(sysConfig).indexTitle), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(sysConfig).indexSubtitle), 1)
        ])
      ]),
      (Object.keys(_unref(userInfo)).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", null, "欢迎，" + _toDisplayString(_unref(userInfo).name), 1),
            _createElementVNode("div", {
              class: "symbol",
              onClick: toLoggedPage
            }, _hoisted_9)
          ]))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "text-login",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/login')))
          }, " 登录 "))
    ])
  ]))
}
}

})